/* -------------------------------------------------------------------------
   Горизонтальная лента карточек.

   Одна и та же логика нужна и в «Best Choices», и в новинках, поэтому она
   лежит отдельно и цепляется к разметке через data-атрибуты:

     [data-mr-rail]        - обёртка
     [data-mr-rail-track]  - прокручиваемая полоса
     [data-mr-rail-prev]   - кнопка назад
     [data-mr-rail-next]   - кнопка вперёд

   Шаг прокрутки считается по первой карточке, а не задаётся числом: ширину
   карточки владелец магазина меняет в настройках секции, и зашитое значение
   разъехалось бы с вёрсткой в тот же день.

   Кнопки гаснут на краях. Без этого человек жмёт «вперёд» на последней
   карточке, ничего не происходит, и он решает, что сайт сломан.

   data-mr-rail-before / data-mr-rail-after на обёртке говорят, что за левым
   или правым краем есть ещё карточки: по ним mr-rail.css на компьютере
   растворяет этот край и ставит на нём стрелку.
   ------------------------------------------------------------------------- */

(function () {
  var EDGE = 4; // допуск на дробные пиксели при масштабировании страницы

  function step(track) {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function sync(rail, track, prev, next) {
    var max = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= EDGE;
    var atEnd = track.scrollLeft >= max - EDGE;
    // Лента короче экрана - управлять нечем, прячем обе кнопки.
    var idle = max <= EDGE;
    rail.toggleAttribute('data-mr-rail-idle', idle);
    rail.toggleAttribute('data-mr-rail-before', !idle && !atStart);
    rail.toggleAttribute('data-mr-rail-after', !idle && !atEnd);
    if (prev) prev.disabled = atStart || idle;
    if (next) next.disabled = atEnd || idle;
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mr-rail]').forEach(function (rail) {
      if (rail.dataset.mrRailReady) return;
      var track = rail.querySelector('[data-mr-rail-track]');
      if (!track) return;
      rail.dataset.mrRailReady = '1';

      var prev = rail.querySelector('[data-mr-rail-prev]');
      var next = rail.querySelector('[data-mr-rail-next]');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(dir) {
        track.scrollBy({ left: dir * step(track), behavior: calm ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      var tick;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = null;
          sync(rail, track, prev, next);
        });
      }, { passive: true });

      window.addEventListener('resize', function () { sync(rail, track, prev, next); });
      // Картинки в карточках грузятся лениво, ширина ленты меняется после -
      // поэтому состояние кнопок пересчитываем ещё и по событию загрузки.
      window.addEventListener('load', function () { sync(rail, track, prev, next); });
      sync(rail, track, prev, next);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
